import Navbar from "../../home/components/Navbar";
import Footer from "../../home/components/Footer";
import BondingLiquidHero from "./components/BondingLiquidHero";
import BondingLiquidTierComparison from "./components/BondingLiquidTierComparison";
import BondingLiquidHowToUse from "./components/BondingLiquidHowToUse";
import BondingLiquidCTA from "./components/BondingLiquidCTA";

export default function BondingLiquidPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <BondingLiquidHero />
      <BondingLiquidTierComparison />
      <BondingLiquidHowToUse />
      <BondingLiquidCTA />
      <Footer />
    </div>
  );
}